<script lang="ts">
      import { onMount, untrack } from 'svelte'
      import { getAnalyticsContext } from './ts/Anatytics.svelte'

      let { id = '772465956473123' } = $props()

      function pixelConsentUpdate(consent: any) {
        if( ! window.fbq || !id ) return
        if( consent.consent == true ) {
          window.fbq('init', id)
          window.fbq('track', 'PageView')
        }
      }

      //function defaultConsent(): { [keyof: string]: 'denied' | 'granted' | undefined } {
      //}

      onMount(() => {

      })

      const analytics = getAnalyticsContext()

      $effect(() => {
            analytics.consent
            untrack(() => {
                  //console.log('pixel consent update', analytics.consent)
                  if (analytics.consent.pixel) pixelConsentUpdate(analytics.consent.pixel)
            })
      })
</script>

<svelte:head>
      {#if id != ''}
            <!-- Meta Pixel Code -->
            <script>
                  !(function (f, b, e, v, n, t, s) {
                        if (f.fbq) return
                        n = f.fbq = function () {
                              n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
                        }
                        if (!f._fbq) f._fbq = n
                        n.push = n
                        n.loaded = !0
                        n.version = '2.0'
                        n.queue = []
                        t = b.createElement(e)
                        t.async = !0
                        t.src = v
                        s = b.getElementsByTagName(e)[0]
                        s.parentNode.insertBefore(t, s)
                        
                  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

            </script>
      {/if}
</svelte:head>

<style lang="postcss">
</style>
